export default "https://cdn-static-staging.gokick.com/assets/8452366be4f72804419de7522b15e5b20c0c8dd8/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";